// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"48":"af8c9f5b","437":"61287eb3","544":"76da6c86","630":"33917b41","732":"2b3bab66","746":"3b8302c9","804":"dcb5b299","834":"b7912332"}[chunkId] + ".chunk.js";
};